import { ReasonStorage, LocalStorageReasonStorage } from './storage'

let current: ReasonStorage = new LocalStorageReasonStorage()

export function getReasonStorage(): ReasonStorage {
  return current
}

export function setReasonStorage(storage: ReasonStorage) {
  current = storage
}
